var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeployment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 30,
    fill: "none",
    viewBox: "0 0 42 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M36.779 11.002c-.18-2.62-2.328-4.687-4.952-4.687-.649 0-1.269.126-1.837.356C29.53 2.911 26.37 0 22.544 0c-2.86 0-5.346 1.625-6.613 4.016a5.911 5.911 0 0 0-1.3-.144c-3.299 0-5.972 2.715-5.972 6.065v.118a9.256 9.256 0 0 0-5.92 2.755A9.54 9.54 0 0 0 0 19.524c0 5.243 4.185 9.494 9.347 9.494h8.466v-5.975a.34.34 0 0 0-.337-.342h-3.352a.342.342 0 0 1-.265-.554l6.876-8.886a.334.334 0 0 1 .53 0l6.877 8.886c.173.224.016.554-.265.554h-3.382a.34.34 0 0 0-.337.342v5.975h8.495a9.246 9.246 0 0 0 6.61-2.78A9.54 9.54 0 0 0 42 19.523c0-3.74-2.128-6.974-5.221-8.522Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h42v29.018H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeployment);
export default __webpack_public_path__ + "static/media/deployment.1ebafd5797049301d0c7a7deadd29ccb.svg";
export { ForwardRef as ReactComponent };